(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  /* On mouse devices the dropdown follows the pointer; a click never leaves it stuck open. */
  var hover = window.matchMedia('(hover: hover) and (min-width: 1101px)');
  var bind = function () {
    document.querySelectorAll('.site-nav [data-dropdown]').forEach(function (item) {
      if (item.dataset.hoverBound) return; item.dataset.hoverBound = '1';
      item.addEventListener('mouseleave', function () {
        if (!hover.matches) return;
        item.classList.remove('is-open');
        var b = item.querySelector('[data-dropdown-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-booking"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var nativeSubmit = function (form) { HTMLFormElement.prototype.submit.call(form); };

  var sending = function (form) {
    var btn = form.querySelector('.invite__submit');
    if (btn && !btn.disabled) { btn.disabled = true; btn.textContent = btn.dataset.sending || 'Sending…'; }
  };

  var reveal = function (form) {
    var section = form.closest('.consult');
    var tpl = section && section.querySelector('template[data-booking-done]');
    var inner = form.closest('.invite__inner');
    if (!tpl || !inner) return Promise.resolve();
    var startH = inner.offsetHeight;
    inner.style.height = startH + 'px';
    form.classList.add('is-leaving');
    return wait(480).then(function () {
      form.innerHTML = '';
      form.appendChild(tpl.content.cloneNode(true));
      form.classList.remove('is-leaving');
      inner.style.height = 'auto';
      var endH = inner.offsetHeight;
      inner.style.height = startH + 'px';
      void inner.offsetHeight;
      inner.style.height = endH + 'px';
      var msg = form.querySelector('[role="status"]');
      if (msg) { msg.setAttribute('tabindex', '-1'); msg.focus({ preventScroll: true }); }
      return wait(750).then(function () { inner.style.height = ''; });
    });
  };

  /* Let Shopify's own spam check run, then hand over to the normal browser submit. */
  var retryNatively = function (form) {
    form.dataset.native = '1';
    var btn = form.querySelector('.invite__submit');
    if (btn) btn.disabled = false;
    if (form.requestSubmit) form.requestSubmit(); else nativeSubmit(form);
  };

  var send = function (form) {
    if (form.dataset.busy) return;
    form.dataset.busy = '1';
    sending(form);
    fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (!res.ok || (res.url && res.url.indexOf('/challenge') > -1)) throw new Error('rejected');
        return res.text().then(function (html) {
          if (/captcha/i.test(html) && html.indexOf('Something went wrong') > -1) throw new Error('captcha');
        });
      })
      .then(function () { return reveal(form); })
      .catch(function () { delete form.dataset.busy; retryNatively(form); });
  };

  var init = function (form) {
    if (form.dataset.ajax) return;
    form.dataset.ajax = '1';
    /* Shopify's spam check calls form.submit() once it has added its token. */
    form.submit = function () {
      if (form.dataset.native || !window.fetch || !window.FormData) return nativeSubmit(form);
      send(form);
    };
  };

  /* Runs after any other submit handlers (bubbling to the document). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('invite__form')) return;
    if (form.dataset.native || !window.fetch || !window.FormData) return;
    init(form);
    if (e.defaultPrevented) { sending(form); return; }
    e.preventDefault();
    send(form);
  });

  var run = function () { document.querySelectorAll('.invite__form').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function (root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var btn = root.querySelector('[data-letter-toggle]');
    var slot = root.querySelector('[data-letter]');
    if (!btn || !slot) return;
    var set = function (open, scroll) {
      slot.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (open && scroll) setTimeout(function () { slot.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 350);
      if (open) { var f = slot.querySelector('textarea'); if (f && scroll) setTimeout(function () { f.focus({ preventScroll: true }); }, 900); }
    };
    btn.addEventListener('click', function () { set(!slot.classList.contains('is-open'), true); });
    if (root.querySelector('[data-letter-open-on-load]')) { set(true, false); }
  };
  var run = function () { document.querySelectorAll('[data-contact]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-materials"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Resting places in the pile: [x, y, rotation]. Positions 1 and 2 peek out on each side. */
  var SPOTS = [[0, 0, -2], [-105, 22, -9], [110, 30, 8], [-40, 44, -4], [45, 50, 3], [-70, 58, -7], [75, 60, 6], [0, 64, 1]];
  var init = function (root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    if (!cards.length) return;
    var names = root.querySelectorAll('[data-material]');
    var links = root.querySelectorAll('[data-material-link]');
    var live = root.querySelector('[data-material-live]');
    var count = root.querySelector('[data-count]');
    var stack = root.querySelector('[data-stack]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var order = cards.map(function (c, i) { return i; });
    var current = 0, busy = false, queued = null;

    var place = function (card, pos) {
      var s = SPOTS[Math.min(pos, SPOTS.length - 1)];
      card.style.setProperty('--x', s[0]);
      card.style.setProperty('--y', s[1]);
      card.style.setProperty('--r', s[2]);
    };
    var layout = function () {
      order.forEach(function (cardIdx, pos) {
        var card = cards[cardIdx];
        place(card, pos);
        card.style.setProperty('--z', String(order.length - pos));
        card.classList.toggle('is-top', pos === 0);
      });
    };
    var mark = function (idx) {
      names.forEach(function (n) { var on = Number(n.dataset.material) === idx; n.classList.toggle('is-active', on); n.setAttribute('aria-pressed', String(on)); });
      links.forEach(function (l) { l.hidden = Number(l.dataset.materialLink) !== idx; });
      if (count) count.textContent = String(idx + 1);
      var card = cards[idx];
      if (live && card) live.textContent = card.textContent.replace(/\s+/g, ' ').trim();
    };

    var kOf = function () { var k = parseFloat(getComputedStyle(stack || root).getPropertyValue('--k')); return isNaN(k) ? 1 : k; };
    var tf = function (x, y, r, k) { return 'translate3d(' + (x * k) + 'px,' + (y * k) + 'px,0) rotate(' + r + 'deg)'; };

    var show = function (idx) {
      idx = ((Number(idx) % cards.length) + cards.length) % cards.length;
      if (idx === current) return;
      if (busy) { queued = idx; return; }
      current = idx;
      mark(idx);
      var card = cards[idx];
      var pos = order.indexOf(idx);
      var from = SPOTS[Math.min(pos, SPOTS.length - 1)];
      var fromZ = String(order.length - pos);
      order = [idx].concat(order.filter(function (i) { return i !== idx; }));

      if (reduce.matches || !card.animate) { layout(); return; }
      busy = true;
      var k = kOf();
      var side = from[0] <= 0 ? -1 : 1;
      var to = SPOTS[0];
      var topZ = String(cards.length + 1);

      /* The chosen card: one continuous move - out to the side, then laid on top. */
      card.classList.add('no-trans');
      var anim = card.animate([
        { transform: tf(from[0], from[1], from[2], k), zIndex: fromZ, easing: 'cubic-bezier(.45,0,.3,1)' },
        { transform: tf(side * 290, -26, side * 11, k), zIndex: fromZ, offset: 0.46, easing: 'step-end' },
        { transform: tf(side * 290, -26, side * 11, k), zIndex: topZ, offset: 0.47, easing: 'cubic-bezier(.25,.8,.25,1)' },
        { transform: tf(to[0], to[1], to[2], k), zIndex: topZ }
      ], { duration: 1320, fill: 'both' });

      /* Everyone else settles gently into their new places while it happens. */
      layout();

      anim.onfinish = function () {
        anim.cancel();
        card.classList.remove('no-trans');
        busy = false;
        if (queued !== null && queued !== current) { var q = queued; queued = null; show(q); } else { queued = null; }
      };
    };

    var hover = window.matchMedia('(hover: hover) and (min-width: 991px)');
    var hoverTimer;
    names.forEach(function (n) {
      n.addEventListener('click', function () { clearTimeout(hoverTimer); show(n.dataset.material); });
      n.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { show(n.dataset.material); }, 280);
      });
      n.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
    });
    root.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(current + Number(b.dataset.step)); });
    });
    if (stack) stack.addEventListener('click', function () { if (cards.length > 1) show(current + 1); });
    root.addEventListener('shopify:block:select', function (e) {
      var li = e.target && e.target.closest ? e.target.closest('li') : null;
      var b = li ? li.querySelector('[data-material]') : null;
      if (b) show(b.dataset.material);
    });
    layout();
  };
  var run = function () { document.querySelectorAll('[data-materials]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-portfolio"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function (root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) return;
    root.classList.add('is-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    root.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
    root.querySelectorAll('.pf-index a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return; e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });
  };
  var run = function () { document.querySelectorAll('[data-portfolio]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();
})();
